import { useState, useEffect, useReducer, useContext } from "react";
import api from "../../services/api";
import { AuthContext } from "../../context/Auth/AuthContext";
import { toast } from "react-toastify";
const reducer = (state, action) => {
  if (action.type === "LOAD_WHATSAPPS") {
    const whatsApps = action.payload;
    return [...whatsApps];
  }

  if (action.type === "UPDATE_WHATSAPPS") {
    const whatsApp = action.payload;
    const whatsAppIndex = state.findIndex((s) => s.id === whatsApp.id);

    if (whatsAppIndex !== -1) {
      state[whatsAppIndex] = whatsApp;
      return [...state];
    } else {
      return [whatsApp, ...state];
    }
  }

  if (action.type === "UPDATE_SESSION") {
    const whatsApp = action.payload;
    const whatsAppIndex = state.findIndex((s) => s.id === whatsApp.id);

    if (whatsAppIndex !== -1) {
      state[whatsAppIndex].status = whatsApp.status;
      state[whatsAppIndex].updatedAt = whatsApp.updatedAt;
      state[whatsAppIndex].qrcode = whatsApp.qrcode;
      state[whatsAppIndex].retries = whatsApp.retries;
      state[whatsAppIndex].number = whatsApp.number;
      return [...state];
    } else {
      return [...state];
    }
  }

  if (action.type === "DELETE_WHATSAPPS") {
    const whatsAppId = action.payload;
    const whatsAppIndex = state.findIndex((s) => s.id === whatsAppId);
    if (whatsAppIndex !== -1) {
      state.splice(whatsAppIndex, 1);
    }
    return [...state];
  }

  if (action.type === "RESET") {
    return [];
  }
};

const useWhatsApps = () => {
  const [whatsApps, dispatch] = useReducer(reducer, []);
  const [loading, setLoading] = useState(true);
  const { user, socket } = useContext(AuthContext);

  // Effect para carregar os dados iniciais
  const fetchSession = async () => {
    if (!user?.companyId) {
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/whatsapp/?session=0");
      dispatch({ type: "LOAD_WHATSAPPS", payload: data });
      setLoading(false);
    } catch (err) {
      console.error("Erro ao carregar WhatsApps:", err);
      setLoading(false);
    }
  };

  useEffect(() => {
    setLoading(true);
    fetchSession();
  }, [user?.companyId]);

  const reload = () => {
    fetchSession();
  };

  /* Removed early return */

  // Effect para configurar os listeners do socket
  useEffect(() => {


    if (user?.companyId && socket && typeof socket.on === 'function' && typeof socket.off === 'function') {
      const companyId = user.companyId;

      const onCompanyWhatsapp = (data) => {
        if (data.action === "update") {
          dispatch({ type: "UPDATE_WHATSAPPS", payload: data.whatsapp });
        }
        if (data.action === "delete") {
          dispatch({ type: "DELETE_WHATSAPPS", payload: data.whatsappId });
        }
      };

      const onCompanyWhatsappSession = (data) => {
        if (data.action === "update") {
          dispatch({ type: "UPDATE_SESSION", payload: data.session });

          // [ANTIGRAVITY] Catch disconnected reasons and notify globally
          if (data.session.status === "DISCONNECTED") {
            const toastOptions = { autoClose: 15000, theme: "colored", toastId: `ws-err-${data.session.id}` };
            if (data.session.disconnectReason === "CONFLICT") {
              toast.error(`⚠️ IMPORTANTE: El teléfono 📞 ${data.session.name} ha sido DESCONECTADO del sistema porque alguien tiene abierto el WhatsApp Web oficial al mismo tiempo. Entra a 'Conexiones' para reiniciar la sesión.`, toastOptions);
            } else if (data.session.disconnectReason === "LOGGED_OUT") {
              toast.error(`⚠️ IMPORTANTE: Alguien desvinculó el teléfono 📞 ${data.session.name} desde la App Móvil de WhatsApp. Necesitas escanear el QR en 'Conexiones'.`, toastOptions);
            } else if (data.session.disconnectReason === "CORRUPTED_CACHE") {
              toast.error(`⚠️ IMPORTANTE: El sistema detectó un fallo en la sesión de 📞 ${data.session.name} y la reinició automáticamente. Por favor, escanea un Nuevo QR en 'Conexiones'.`, toastOptions);
            } else {
              toast.error(`⚠️ IMPORTANTE: El teléfono 📞 ${data.session.name} se ha desconectado. Ve a 'Conexiones' para revisar el estado.`, toastOptions);
            }
          }
        }
      };

      const whatsappEvent = `company-${companyId}-whatsapp`;
      const sessionEvent = `company-${companyId}-whatsappSession`;

      socket.on(whatsappEvent, onCompanyWhatsapp);
      socket.on(sessionEvent, onCompanyWhatsappSession);

      return () => {
        if (socket && typeof socket.off === 'function') {
          socket.off(whatsappEvent, onCompanyWhatsapp);
          socket.off(sessionEvent, onCompanyWhatsappSession);
        }
      };
    }
  }, [socket, user?.companyId]); // Dependências corretas

  return { whatsApps, loading, reload };
};

export default useWhatsApps;
